import { render, staticRenderFns } from "./userportrait.vue?vue&type=template&id=0940fb22&scoped=true&"
import script from "./userportrait.vue?vue&type=script&lang=js&"
export * from "./userportrait.vue?vue&type=script&lang=js&"
import style0 from "./userportrait.vue?vue&type=style&index=0&id=0940fb22&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0940fb22",
  null
  
)

export default component.exports